import getPercents from "../../animate/utils/percents/get-percents";
import getPercentsString from "../../animate/utils/get-percents-string";

/**
 * Check if the value is number or string and set the percents method accordingly
 * @param {StorageItemProps} item
 */
const setPercentsMethod = (item) => {
  const isNumber = item.get("v_is-number");

  item.set("get-percents", isNumber ? getPercents : getPercentsString);
};

export default setPercentsMethod;
